import type { SortOption } from 'src/redux/productsQuery/types/SortOption';

export const getListingsSortAsURLSearchParams = (
  urlParams: URLSearchParams,
  activeSortOption: SortOption,
): void => {
  if (!activeSortOption.key) {
    return;
  }

  const shortenedKey = activeSortOption.key.replace(/^attributes\./, 'a.');
  const direction = activeSortOption.descending ? '-desc' : '-asc';

  urlParams.set('sort', `${shortenedKey}${direction}`);
};
